module.exports = __webpack_public_path__ + "media/images/homes/UnitCostMargins-0dac4308babe4370c4b9ff1d68b6f131.png";